import { SimpleEmitter } from './SimpleEmitter';
import { BackwardCompatibleAssistantPlatformSdk } from './BackwardCompatibleAssistantPlatformSdk';
export function initSideEffectEmitterSingleton() {
  if (!window.__AGENT_PLATFORM_BM_SDK_SIDE_EFFECT_EMITTER__) {
    window.__AGENT_PLATFORM_BM_SDK_SIDE_EFFECT_EMITTER__ = new SimpleEmitter();
  }
  if (!window.___AGENT_PLATFORM_BM_SDK__) {
    // TODO: Remove this backward compatibility code in the future
    // `getActiveListeners()` and `setActiveListenersObserver()` methods were in use by `@wix/chat-service-sdk`

    window.___AGENT_PLATFORM_BM_SDK__ = new BackwardCompatibleAssistantPlatformSdk(window.__AGENT_PLATFORM_BM_SDK_SIDE_EFFECT_EMITTER__);
  }
  return window.__AGENT_PLATFORM_BM_SDK_SIDE_EFFECT_EMITTER__;
}
//# sourceMappingURL=hooks.js.map